module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-400.woff2?1a280523d375e9358d5229df34fc8e94";